import request from '@/axios'


export function getModuleAnalyticsSettings (module_id, customer_id, summary_id = 0) {
  return request({
    url: `/analytics/platform_modules/${module_id}/${customer_id}/${ summary_id }`,
    method: 'GET'
  })
}

export function saveUserModuleAnalyticsSetting (postData) {
  return request({
    url:'analytics/platform_modules/',
    method:'POST',
    data: postData
  })
}

export function updateStatForDashboard (postData) {
  return request({
    url:'analytics/platform_modules/update',
    method:'POST',
    data: postData
  })
}
  
  
export function deleteUserModuleAnalyticsSetting (deleteData) {
  return request({
    url:'analytics/platform_modules/',
    method:'DELETE',
    data: deleteData
  })
}

export function getUserAnalytics (module_id, customer_id, summery_id) {
  return request({
    url: `/analytics/platform_modules/fetch/${module_id}/${customer_id}/${summery_id}/0`,
    method: 'GET'
  })
}
  
export function getStatusList (customer_id, project_id) {
  return request({
    url: `projects/kanban/${project_id}/${customer_id}`,
    method: 'GET'
  })
}

export function getAllAnalyticsForDashboard (customer_id) {
  return request({
    url: `/fetch_all_analytics_modules/${ customer_id }/1`,
    method: 'GET'
  })
}

export function platformModuleslist () {
  const customer_id = localStorage.getItem('customer_id')
  return request({
    
    url: `/analytics/platform_modules/platform_module_list/${customer_id}`,
    method: 'GET'
  })
}


export function analyticsStatus (postData) {
  return request({
    url:'analytics/platform_modules/set_view_state',
    method:'POST',
    data: postData
  })
}